import React, { createContext, useRef, useContext, useState, ReactNode, SetStateAction, Dispatch } from "react";

type PlayerRefContextType = {
  playerRef: React.Ref<any>,
  isLoading: boolean,
  setIsLoading: Dispatch<SetStateAction<boolean>>,
}

const PlayerRefContext = createContext<PlayerRefContextType | undefined>(undefined);

type PlayerRefProviderProps = { children: ReactNode }

export const PlayerRefProvider: React.FC<PlayerRefProviderProps> = ({ children }) => {
  const playerRef = useRef(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  return (
    <PlayerRefContext.Provider value={{ playerRef, isLoading, setIsLoading }}>
      {children}
    </PlayerRefContext.Provider>
  );
};

export const usePlayerRef = () => {
  const context = useContext(PlayerRefContext);
  if (!context) {
    throw new Error("usePlayerRef must be used within a PlayerRefProvider");
  }
  return context;
};
